<!-- Premium fermé : le paywall n'existe pas, d'où qu'on l'appelle. -->
@if (premiumService.premiumEnabled()) {
<vw-toast-popup
  [isOpen]="isOpen"
  [title]="isTrialEnding ? '' : (titleKey | translate)"
  (close)="onClose()"
>
  <!-- Paywall : le titre selon la source passe par la ligne de titre commune.
       Fin d'essai : son bandeau vert profond fait office d'en-tête. -->
  <div class="px-4 pb-4" [class.pt-6]="isTrialEnding">
    @if (isTrialEnding) {
    <!-- Fin d'essai (rappels J-5 et J-1, CR-02) : la date, puis ce que l'essai
         a apporté. Une ligne à zéro ne s'affiche pas ; sans bilan, les
         formules seules. -->
    <div
      class="-mx-4 -mt-6 mb-4 bg-gradient-to-br from-vw-primary-pressed to-[#093935] px-4 py-6 pr-14 text-white"
    >
      <h2 class="font-display text-2xl font-semibold">
        @if (trialEndLabel) {
          {{ "premium.trial-ending.title" | translate: { date: trialEndLabel } }}
        } @else {
          {{ "premium.trial-ending.title-soon" | translate }}
        }
      </h2>
    </div>
    @if (trialSummary?.willyAnswers) {
      <p class="mb-2 text-sm text-vw-ink">
        {{ "premium.trial-ending.recap-intro" | translate }}
      </p>
      <ul class="mb-5 flex flex-col gap-3 rounded-2xl border border-[#E3E8E5] px-4 py-3">
        <li class="text-sm font-medium text-vw-ink">
          {{
            "premium.trial-ending.recap-willy"
              | vwPlural: trialSummary?.willyAnswers ?? 0
          }}
        </li>
      </ul>
    } @else {
      <p class="mb-5 text-sm text-vw-ink">
        {{ "premium.trial-ending.no-recap" | translate }}
      </p>
    }
    } @else {
    <!-- Premier avantage selon la source (CR-01, maquette 04) ; le titre est dans la ligne de titre. -->
    <ul class="mb-3 flex flex-col gap-3">
      @for (key of benefits; track key) {
        <li class="flex items-start gap-3">
          <span
            class="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-vw-surface-tint"
          >
            <svg
              class="h-3 w-3 text-vw-primary"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M5 13l4 4L19 7"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="text-sm text-vw-ink">
            {{ "premium.paywall.benefits." + key | translate }}
          </span>
        </li>
      }
    </ul>
    <p class="mb-5 text-xs leading-relaxed text-vw-muted">
      {{ "premium.paywall.trust" | translate }}
    </p>
    }

    <!-- Formules, l'annuel en tête et présélectionné. L'économie est CALCULÉE
         depuis les prix du fournisseur : écrite en dur, elle deviendrait fausse
         dès qu'un palier change ou que le pays diffère. -->
    @if (pricesUnavailable) {
      <div class="mb-4">
        <vw-error-state
          [compact]="true"
          [titleKey]="null"
          messageKey="premium.paywall.prices-unavailable"
          [retrying]="pricing.loading()"
          (retry)="retryPrices()"
        ></vw-error-state>
      </div>
    } @else if (!isOutdatedApp && !webCheckoutUnavailable) {
      <div class="mb-4 flex flex-col gap-3" [attr.aria-busy]="pricesLoading">
        @for (plan of ["YEARLY", "MONTHLY"]; track plan) {
          <button
            type="button"
            (click)="selectPlan($any(plan))"
            class="flex min-h-[60px] items-center gap-3 rounded-2xl border-2 px-4 py-3 text-left transition"
            [ngClass]="
              selectedPlan === plan
                ? 'border-vw-primary bg-[#F2FAF5]'
                : 'border-[#E3E8E5] bg-white'
            "
            [attr.aria-pressed]="selectedPlan === plan"
          >
            <span
              class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2"
              [ngClass]="
                selectedPlan === plan
                  ? 'border-vw-primary bg-vw-primary'
                  : 'border-vw-icon-idle'
              "
              aria-hidden="true"
            >
              @if (selectedPlan === plan) {
                <svg class="h-3 w-3 text-white" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              }
            </span>
            <span class="min-w-0 flex-1">
              <span class="block text-base font-semibold text-vw-ink">
                {{
                  (plan === "YEARLY"
                    ? "premium.paywall.plan-yearly"
                    : "premium.paywall.plan-monthly"
                  ) | translate
                }}
              </span>
              @if (pricing.hasPrice(plan)) {
                <span class="block text-xs text-vw-muted">
                  @if (plan === "YEARLY") {
                    @if (pricing.yearlySaving(); as saving) {
                      {{ "premium.paywall.yearly-detail-saving" | translate: { price: pricing.label(plan), saving: saving } }}
                    } @else {
                      {{ "premium.paywall.yearly-detail" | translate: { price: pricing.label(plan) } }}
                    }
                  } @else {
                    {{ "premium.paywall.monthly-detail" | translate: { price: pricing.label(plan) } }}
                  }
                </span>
              } @else {
                <!-- Prix en route : un emplacement, jamais « —/an » -->
                <span
                  class="mt-1 block h-4 w-32 animate-pulse rounded-md bg-[#E3E8E5]"
                  aria-hidden="true"
                ></span>
              }
            </span>
            @if (plan === "YEARLY" && premiumService.trialOffer("YEARLY"); as offer) {
              <span
                class="shrink-0 rounded-full bg-vw-warn-bg px-2 py-0.5 text-[11px] font-semibold text-vw-warn-ink"
              >
                {{ "premium.paywall.trial-chip" | translate: { days: offer.days } }}
              </span>
            }
          </button>
        }
      </div>
    }

    @if (isOutdatedApp) {
      <p class="mb-3 rounded-xl bg-vw-premium-bg px-3 py-2 text-sm text-vw-premium-ink">
        {{ "premium.paywall.update-app" | translate }}
      </p>
      <!-- Sans ce bouton, l'encart était un cul-de-sac -->
      <vw-button
        look="primary"
        [label]="'premium.paywall.update-app-cta' | translate"
        customClass="w-full"
        (click)="openStore()"
      />
    } @else if (isGuest) {
      <p class="mb-3 rounded-xl bg-vw-premium-bg px-3 py-2 text-sm text-vw-premium-ink">
        {{ "premium.paywall.account-required" | translate }}
      </p>
    } @else if (activating) {
      <p class="mb-3 text-center text-sm text-vw-muted">
        {{
          (activationSlow
            ? "premium.paywall.activation-slow"
            : "premium.paywall.activating"
          ) | translate
        }}
      </p>
    } @else {
      @if (webCheckoutUnavailable) {
        <p class="mb-3 rounded-xl bg-[#F2FAF5] px-3 py-2 text-sm text-[#1C5C41]">
          {{ "premium.paywall.subscribe-in-app" | translate }}
        </p>
      } @else {
        <!-- Un changement de formule ne prend pas effet tout de suite : la
             periode deja reglee court jusqu'a son terme. Le taire laisserait
             croire a un double prelevement. -->
        @if (isPlanChange && currentPeriodEndLabel) {
          <p
            class="mb-2 rounded-xl bg-[#F2FAF5] px-3 py-2 text-xs leading-relaxed text-[#1C5C41]"
          >
            {{
              "premium.paywall.plan-change-from"
                | translate: { date: currentPeriodEndLabel }
            }}
          </p>
        }
        <!-- Libellés fixés (K6) : l'essai seulement quand il est vrai ici. -->
        <vw-button
          look="primary"
          data-test="paywall-primary"
          [label]="
            canKeepCurrentPlan
              ? ((selectedPlan === 'YEARLY'
                  ? 'premium.trial-ending.keep-yearly'
                  : 'premium.trial-ending.keep-monthly'
                ) | translate)
              : isCurrentPlan
              ? ('premium.paywall.cta-current' | translate)
              : isTrialEnding
                ? ('premium.trial-ending.cta' | translate)
              : trial
                ? ('premium.paywall.cta-trial-days' | translate: { days: trial.days })
                : ((selectedPlan === 'YEARLY'
                    ? 'premium.paywall.cta-continue-yearly'
                    : 'premium.paywall.cta-continue-monthly'
                  ) | translate)
          "
          [loading]="loading"
          [disabled]="!canKeepCurrentPlan && !canPurchase && !(trial && !trial.store)"
          customClass="w-full"
          (click)="onPrimaryClick()"
        />
        <!-- Le prix exact et la résiliation, AVANT tout clic -->
        @if (pricing.hasPrice(selectedPlan) && !isCurrentPlan && !isTrialEnding) {
          <p class="mt-2 text-center text-xs text-vw-muted">
            {{
              (trial
                ? (selectedPlan === "YEARLY" ? "premium.paywall.then-yearly" : "premium.paywall.then-monthly")
                : (selectedPlan === "YEARLY" ? "premium.paywall.price-yearly" : "premium.paywall.price-monthly")
              ) | translate: { price: pricing.label(selectedPlan) }
            }}
          </p>
        }
        @if (isTrialEnding) {
          <!-- Le premier débit tombe à la fin de l'essai : le dire évite de
               croire à un paiement des jours encore offerts. -->
          @if (billingStartLabel && pricing.hasPrice(selectedPlan)) {
            <p class="mt-1 text-center text-xs text-vw-muted">
              {{
                (selectedPlan === "YEARLY"
                  ? "premium.trial-ending.billing-yearly"
                  : "premium.trial-ending.billing-monthly"
                )
                  | translate
                    : {
                        price: pricing.label(selectedPlan),
                        date: billingStartLabel,
                      }
              }}
            </p>
          }
          <button
            type="button"
            class="mt-3 w-full text-center text-sm font-medium text-[#1C5C41] underline"
            (click)="stayFree()"
          >
            {{ "premium.trial-ending.stay-free" | translate }}
          </button>
        }
      }

      <!-- Achat en attente d'un accord (« Demander a acheter », controle
           parental) : l'acces n'est pas immediat, et le taire laisserait croire
           a un echec. -->
      @if (purchasePending) {
        <p
          class="mt-2 rounded-xl bg-vw-premium-bg px-3 py-2 text-xs leading-relaxed text-vw-premium-ink"
        >
          {{ "premium.store.pending" | translate }}
        </p>
      }

      <!-- « Restaurer mes achats » : EXIGE par Apple pour toute app vendant un
           abonnement. Sans lui, quelqu'un qui reinstalle l'app ne retrouve pas
           ce qu'il a paye — et c'est un motif de refus. Sans objet sur le web,
           ou l'abonnement suit le compte et non l'appareil. -->
      @if (isStore) {
        <button
          type="button"
          class="mt-3 w-full text-center text-xs font-medium text-[#1C5C41] underline disabled:opacity-50"
          [disabled]="restoring"
          (click)="restorePurchases()"
        >
          {{ "premium.store.restore" | translate }}
        </button>
        @if (restored === false) {
          <p class="mt-1 text-center text-xs text-vw-muted">
            {{ "premium.store.restore-none" | translate }}
          </p>
        }
      }
    }

    @if (keepFailed) {
      <p class="mt-2 text-center text-body-s text-vw-danger" role="alert">
        {{ "errors.businessException" | translate }}
      </p>
    }

    @if (error) {
      <!-- Un tunnel de paiement qui n'a pas pu s'ouvrir n'est pas la faute de
           l'utilisateur : on dit ce qui s'est passé et on laisse réessayer,
           plutôt qu'un « erreur » sec qui laisse croire à un refus. -->
      <p class="mt-2 text-center text-sm text-vw-premium-ink">
        {{ "premium.paywall.checkout-failed" | translate }}
      </p>
    }

    <!-- Exige par Apple sur l'ecran d'achat d'un abonnement (regle 3.1.2) -->
    <p class="mt-4 flex justify-center gap-4 text-xs text-vw-muted">
      <button type="button" class="underline" (click)="openLegal(termsUrl)">
        {{ "premium.paywall.terms" | translate }}
      </button>
      <button type="button" class="underline" (click)="openLegal(privacyUrl)">
        {{ "premium.paywall.privacy" | translate }}
      </button>
    </p>
  </div>
</vw-toast-popup>
}
